import React from 'react';
import { DEFAULT_LANGUAGE, LANGUAGE_NAMES } from '../../../service/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';

const LanguageDropdown = ({ availableLanguages, currentLanguage, onLanguageChange }) => {
    if (!availableLanguages) {
        return null;
    }
    
    const onlyOneLanguage = availableLanguages.length === 1;

    const handleChange = (event) => {
        const newLang = event.target.value;
        if (newLang !== currentLanguage) {
            onLanguageChange(newLang);
        }
    };
    
    return (
        <div className="language-dropdown">
            <div className="d-flex align-items-center" style={{ position: 'relative' }}>
                <FontAwesomeIcon icon={faGlobe} className="mr-2" style={{ position: 'absolute', left: '8px', top: '50%', transform: 'translateY(-50%)' }} />
                <select 
                    className="form-control pl-4" 
                    value={currentLanguage} 
                    onChange={handleChange}
                    disabled={onlyOneLanguage}
                    title={onlyOneLanguage ? `Sólo disponible en ${LANGUAGE_NAMES[availableLanguages[0]] || availableLanguages[0]}` : ''}
                    style={{ cursor: onlyOneLanguage ? 'not-allowed' : 'pointer', maxWidth: '400px' }}
                >
                    {availableLanguages.map(lang => (
                        <option key={lang} value={lang}>
                            {LANGUAGE_NAMES[lang] || lang}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    );
};

export default LanguageDropdown;
